var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWebhook = function SvgWebhook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M11.975 7.7a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M5.175 19.2a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M18.675 19.2a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M15.5 21c1.8 1.8 4.6 1.8 6.4 0s1.8-4.6 0-6.4c-1.5-1.5-3.8-1.7-5.5-.7l-3.773-6.355"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M3.95 13.4c-1.8.5-3.2 2.3-3.2 4.3 0 2.5 2 4.5 4.5 4.5s4.5-2 4.5-4.5h7.43"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M16.375 7.4c.3-1.5-.1-3.1-1.2-4.2-1.8-1.8-4.6-1.8-6.4 0-2 2.1-1.7 5.5.9 7.1l-3.586 6.202"
  })));
};
export default SvgWebhook;